// extracted by mini-css-extract-plugin
export default {"sortInfoIcon":"sortInfoIcon__ZmY4Y","sortInfoTooltip":"sortInfoTooltip__NDg1Y"};